<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-12-09 14:17:25
 -->
<!--  -->
<template>
  <basicContainer>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      v-model="form"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @sort-change="sortChange"
      @on-load="onLoad"
      @refresh-change="refresh"
      @expand-change="expandChange"
    >
    <!-- @cell-click="cellClick" 和行选择有冲突，暂时注销 -->
   <template slot="summary" slot-scope="{row}">
      <div v-html="row.summary" style="text-align: left;"></div>
   </template>
   <template slot="expand" slot-scope="{row}">
    <basicContainer style="background:#73b4ef">
      <el-steps :space="200" ref='steps' :active="getActiveIndex(row.stepsTopInfo)"   align-center v-loading="row.loading" >
        <el-step v-for="(activity) in row.stepsTopInfo" :key="activity.processInstanceId" :description="activity.endTime || '进行中'" :icon="activity.icon"  :title="activity.taskName" ></el-step>
      </el-steps>
      <el-table
      :data=" row.stepsInfo"
      v-loading="row.loading"
      style="width: 100%;">
      <el-table-column
        prop="taskName"
        label="环节名称">
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="办理时间">
      </el-table-column>
      <el-table-column
        prop="assigneeName"
        label="办理用户"></el-table-column>
          <el-table-column
        prop="content"
        label="修改详情">
         <template slot-scope="{ row }">
            <el-popover
              placement="top-start"
              v-for="(item,index) in row.content"
              :key="index"
              trigger="hover"
              :title="item.name"
              width="200"
              :content="`${item.old?item.old+ '修改为':'' }${item.new}`">
              <el-tag  slot="reference"  style="margin:5px; width:250px;overflow:hidden" type="primary" >{{item.name}}:{{item.old?item.old +'  改变为  ' :''}} {{item.new}}</el-tag>
            </el-popover>

        </template>

        </el-table-column>

    </el-table>
    </basicContainer>
  </template>
   <template slot-scope="{type,size,row}" slot="menu">
     <el-button  :size="size" :type="type" @click="doTask(row)">查看 </el-button>
     <!-- <el-button  :size="size" :type="type">自定义菜单按钮</el-button> -->
  </template>

    </avue-crud>
  </basicContainer>
</template>

<script>

import {
  dateFormat
} from '@/framework/util/date'

export default {
  name: 'Todo',
  data() {
    return {
      form: {},
      order: {},
      query: {},
      loading: true,
      page: {
        pageSize: 15,
        pageSizes: [15, 25, 35, 45],
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        expand: true,
        expandRowKeys: [],
        // expandFixed: true,
        rowKey: 'processInstanceId',
        dialogWidth: 1000,
        dialogHeight: 400,
        searchMenuSpan: 6,
        align: 'center',
        tip: true,
        stripe: true,
        border: true,
        index: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        menuWidth: 120,
        delBtn: false,
        // menu: false,
        selection: false,
        column: [
          {
            prop: 'keyword',
            label: '关键字',
            search: true,
            hide: true,
            showColumn: false
          },
          {
            prop: 'processCode',
            label: '流程编码',
            hide: true,
            type: 'input'
          }, {
            prop: 'businessTitle',
            label: '标题',
            type: 'input'
          }, {
            prop: 'summary',
            label: '摘要',
            slot: true,
            minWidth: 120
          }, {
            prop: 'processDefinitionKey',
            label: '流程名称',
            search: true,
            hide: true,
            showColumn: false,
            type: 'select',
            dicData: []
          },
          {
            prop: 'workflowStatus',
            label: '流程状态',
            search: true,
            hide: true,
            type: 'select',
            dicData: [{
              label: '所有',
              value: 'all'
            }, {
              label: '已完成',
              value: 'finish'
            }, {
              label: '处理中',
              value: 'processing'
            }]
          }, {
            prop: 'processInstanceStartUserName',
            label: '流程发起人',
            hide: true,
            type: 'input'
          }, {
            prop: 'processInstanceName',
            label: '流程实例名',
            type: 'input'
          }, {
            prop: 'taskName',
            label: '任务名称',
            formatter: (row, value) => value || '已完成',
            type: 'input'
          }, {
            prop: 'taskAssigneeName',
            label: '执行人/完成人',
            type: 'input'
          }, {
            prop: 'processStatus',
            label: '流程状态',
            type: 'input'
          }, {
            prop: 'processInstanceStartTime',
            formatter: (row, value) => dateFormat(new Date(value)),
            label: '流程发起时间',
            type: 'input'
          }
        ]
      },
      data: []

    }
  },

  components: {},

  mounted() {
    this.getProcessDefinitionKeySelect(true)
  },
  activated() {
    this.onLoad()
  },
  methods: {
    /** 加载流程名称的select 下拉框 */
    getProcessDefinitionKeySelect(involvedMe) {
      this.$http.get('/flow-ext/process-definition-list', {
        params: {
          involvedMe
        }
      }).then(response => {
        if (response.data instanceof Array) {
          let index = this.option.column.findIndex(item => item.prop === 'processDefinitionKey')
          this.$set(this.option.column[index], 'dicData', response.data.map(item => ({
            label: item.name,
            value: item.key
          })))
        }
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      })
    },
    cellClick: function(row, column, cell, event) {
      if (column.label !== '操作' && column.label) {
        if (!this.option.expandRowKeys.includes(row.processInstanceId)) {
          this.option.expandRowKeys.push(row.processInstanceId)
          this.expandChange(row, this.option.expandRowKeys)
        } else {
          this.option.expandRowKeys = []
          this.expandChange(row, this.option.expandRowKeys)
        }
      }
    },
    refresh: function() {
      this.onLoad()
    },
    sortChange(value) {
      this.order.prop = value.prop
      this.order.order = value.order
      this.onLoad()
    },
    searchReset() {
      this.query = {}
      this.onLoad()
    },
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      done()
      this.query = params
      this.page.currentPage = 1
      this.onLoad()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      this.option.expandRowKeys.splice(0, this.option.expandRowKeys.length)
      let orderItemList = []
      if (order.oder) {
        orderItemList.push({
          asc: order.oder === 'ascending',
          column: order.prop
        })
      }
      this.loading = true
      params.pageNum = page.currentPage
      params.pageSize = page.pageSize
      params.orderByStatusFirst = true
      this.$http.get('/flow-ext/my-apply', { params }).then(
        response => {
          this.loading = false
          response.data.records
            .filter(item => (item.taskAssigneeName === '' || item.taskAssigneeName === null || item.taskAssigneeName === ''))
            .forEach(item => {
              item.taskAssigneeName = item.lastExecutorName
            })
          this.data = response.data.records
          this.page.total = response.data.total || response.data.records.length
          this.selectionClear()
        }
      ).catch(
        error => {
          this.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    expandChange(row, expendList) {
      // 和行选择有冲突，暂时注销
      // if (expendList.length) {
      //   this.option.expandRowKeys = []
      //   if (row) {
      //     this.option.expandRowKeys.push(row.processInstanceId)
      //   }
      // } else {
      //   this.option.expandRowKeys = []
      // }
      if (!row.stepsTopInfo) {
        row.loading = true
        this.$http.get('/flow-info/detail', {
          params: {
            'processInstanceId': row.processInstanceId,
            'showFirstModifyRecord': false,
            'showRepotModifyRecord': false
          }
        }).then(response => {
          // response.data = response.data.concat(response.data).concat(response.data).concat(response.data)
          row.loading = false
          this.$set(row, 'stepsTopInfo', [])
          // 这里处理顶部的进度条
          if (response.data.length > 10) {
            row.stepsTopInfo.push({
              icon: 'el-icon-success',
              taskName: response.data[0].taskName,
              processInstanceId: response.data[0].processInstanceId,
              endTime: response.data[0].endTime

            })
            row.stepsTopInfo.push({
              icon: 'el-icon-more',
              taskName: `${response.data.length - 10}步`,
              processInstanceId: `${response.data.length - 10}步`,
              endTime: '...'
            })
            response.data.forEach((item, index) => {
              if (index > (response.data.length - 9)) {
                row.stepsTopInfo.push({
                  icon: item.endTime ? 'el-icon-success' : '',
                  taskName: item.taskName,
                  processInstanceId: item.processInstanceId,
                  endTime: item.endTime
                })
              }
            })
          } else {
            response.data.forEach((item, index) => {
              row.stepsTopInfo.push({
                icon: item.endTime ? 'el-icon-success' : '',
                taskName: item.taskName,
                processInstanceId: item.processInstanceId,
                endTime: item.endTime
              })
            })
          }
          // 判断最后一个环节是否巨有结束时间
          if (row.stepsTopInfo[row.stepsTopInfo.length - 1].endTime) {
            row.stepsTopInfo.push({
              icon: 'el-icon-success',
              endTime: '已完成',
              taskName: '完成'
            })
          } else {
            row.stepsTopInfo.push({
              icon: 'el-icon-more',
              endTime: '...'
            }, {
              icon: 'el-icon-success',
              endTime: '',
              taskName: '完成'
            })
          }
          let stepInfo = response.data
          if (Array.isArray(stepInfo)) {
            stepInfo.forEach(element => {
              // 有结束时间，则该环节审核已完成
              element.content = []
              if (element.endTime) {
                // 对表单操作数据，将数据变化展示
                if (element.modifyContent.length > 0) {
                  for (let index = 0; index < element.modifyContent.length; index++) {
                    let item = element.modifyContent[index]
                    element.content.push({
                      name: item.executeFieldLabel,
                      old: item.executeValueOldText,
                      new: item.executeValueText
                    })
                  }
                }
              } else {
                element.content = []
              }
            })
          }
          row.stepsInfo = response.data
        }).catch(error => {
          row.loading = false
          this.$message.error(error.msg || error.message)
        })
      }
    },
    getActiveIndex(stepsTopInfo) {
      if (Array.isArray(stepsTopInfo) && stepsTopInfo.length) {
        let index = stepsTopInfo.findIndex(item => !item.endTime)
        return index === -1 ? stepsTopInfo.length : index + 1
        // return stepsTopInfo[stepsTopInfo.length - 1].endTime ? stepsTopInfo.length : stepsTopInfo.length - 1
      }
    },
    doTask(row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: row.processInstanceId,
          taskId: null,
          formId: null,
          pageKey: 'VIEW'
        }
      })
    }

  }
}
</script>
<style lang='scss' scoped>
</style>
